import { render, staticRenderFns } from "./IconCar.vue?vue&type=template&id=5d0c91ae&"
import script from "./IconCar.vue?vue&type=script&lang=js&"
export * from "./IconCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports